import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export default function NotFound() {
  const location = useLocation();
  useEffect(() => {
    console.error('404:', location.pathname);
  }, [location.pathname]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'hsl(38, 20%, 88%)',
      }}
    >
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h1 className="font-display" style={{ margin: '0 0 0.5rem', fontSize: 'clamp(3rem,10vw,5rem)' }}>
          404
        </h1>
        <p style={{ margin: '0 0 1.25rem', fontSize: '1.125rem', opacity: 0.6 }}>Page not found</p>
        <Link to="/" className="font-mono-luxe underline-luxe" style={{ fontSize: '11px', letterSpacing: '0.2em' }}>
          Return to Home
        </Link>
      </div>
    </div>
  );
}
